import React, { useContext } from "react"

export { default as SegmentSelection } from "./SegmentSelection"

const SegmentSelectionTypeContext = React.createContext()
const useSegmentSelectionType = () => useContext(SegmentSelectionTypeContext)

export { SegmentSelectionTypeContext, useSegmentSelectionType }
